export default function ProgressBar({ current, total, score = null }) {
    const pct = total > 0 ? Math.round((current / total) * 100) : 0;

    return (
        <div className="progress-bar-container">
            <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${pct}%` }} />
            </div>
            <span className="progress-label">
                {current}/{total}
                {score !== null && ` — Score: ${score}`}
            </span>
        </div>
    );
}
